import { debounce } from "throttle-debounce";

import { AutodeskViewer } from "../components/autodeskViewer";
import { IZoomEvent } from "../interfaces";
import { Point } from "../models/point";

export class ZoomManager {
	private onZoomChange?: (context: IZoomEvent) => void;

	public constructor(private autodeskViewer: AutodeskViewer) {}

	public registerOnCameraChangedEvent(onZoomChange: (context: IZoomEvent) => void) {
		this.onZoomChange = onZoomChange;
		this.autodeskViewer.viewer.addEventListener(Autodesk.Viewing.CAMERA_CHANGE_EVENT, this.debounceOnCameraChanged);
	}

	public unregisterOnCameraChangedEvent() {
		this.debounceOnCameraChanged.cancel();
		if (this.onZoomChange != null) {
			this.autodeskViewer.viewer.removeEventListener(Autodesk.Viewing.CAMERA_CHANGE_EVENT, this.debounceOnCameraChanged);
		}
	}

	/**
	 * Debounce event onCameraChanged so this event is triggered on the client component
	 *  at most once per 100 milliseconds
	 *
	 * @see https://www.npmjs.com/package/throttle-debounce
	 */
	private debounceOnCameraChanged = debounce(100, (event) => {
		if (this.onZoomChange) {
			this.onZoomChange({
				zoom: {
					viewFromPosition: new Point(event.camera.position.x, event.camera.position.y),
					zoomLevel: event.camera.position.z,
					viewAtPosition: new Point(event.camera.target.x, event.camera.target.y),
				},
			});
		}
	});
}
